import styled, { keyframes } from "styled-components";
import { shade } from "polished";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  background-color: #f5f5f5;
  padding: 24px 0px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimatedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${appearFromLeft} 1s;
  background-color: white;
  width: 95%;
  form {
    margin: 24px 0 16px 0;
    width: 360px;
    text-align: center;
    @media (max-width: 360px) {
      width: 95vw;
    }
    h1 {
      margin-bottom: 24px;
    }
    a {
      color: ${shade(0.2, "#002244")};
      display: block;
      margin-top: 12px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }
  > a {
    color: #ff9000;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    &:hover {
      color: ${shade(0.2, "#ff9000")};
    }
    svg {
      margin-right: 16px;
    }
  }
`;
